import { render, staticRenderFns } from "./GrainTypeAdd.vue?vue&type=template&id=5fcf4a9b&scoped=true"
import script from "./GrainTypeAdd.vue?vue&type=script&lang=js"
export * from "./GrainTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./GrainTypeAdd.vue?vue&type=style&index=0&id=5fcf4a9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf4a9b",
  null
  
)

export default component.exports